import { render } from "./CarouselGallery.vue?vue&type=template&id=bf070906&scoped=true"
import script from "./CarouselGallery.vue?vue&type=script&lang=js"
export * from "./CarouselGallery.vue?vue&type=script&lang=js"

import "./CarouselGallery.vue?vue&type=style&index=0&id=bf070906&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf070906"]])

export default __exports__